export default __webpack_public_path__ + "static/media/impact-of-Mars.211d2c23.jpg";